<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.table && localService.languageContent.product_config">
    <div class="banner center" style="max-width:1400px;">
        <div class="row row_header freeze_col freeze_height">
            <div class="col-6">
                <div style="float: left;">
                    <a class="button" [routerLink]="['/products' + localService.basicParamsString,businessId]">
                        <i class="material-icons button icon_adjust">arrow_back</i>
                    </a>
                    <button class="button_icon button_icon_color icon_adjust" style="margin-left: 10px;"
                        (click)="onLoad()">replay_circle_filled</button>
                    <label style="font-weight: normal;margin-left: 30px;">
                        <input type="checkbox" [(ngModel)]="isOnlyActive" (change)="onLoad()" />
                        <span class="normal_color">{{localService.languageContent.common.is_active}}</span>
                    </label>
                </div>
                {{localService.languageContent.table.title}}
            </div>
            <div [ngClass]="isDirectStockDisabled ? 'col-6' : 'col-3'">
                {{localService.languageContent.table.stock}}
            </div>
            <div class="col-3" *ngIf="!isDirectStockDisabled">
                {{localService.languageContent.common.add}}
            </div>
        </div>
        <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
            <div class="row styled_row freeze_col" *ngFor="let item of items">
                <div class="col-6">
                    <button class="button_icon icon_adjust"
                        title="{{item.v4 == '1' ? localService.languageContent.table.make_inactive : localService.languageContent.table.make_active}}"
                        (click)="onActiveInactiveStatus(item.key)"
                        [ngStyle]="{'color': item.v4 == '1' ? 'yellowgreen' : 'orangered' }">{{item.v4 == '1' ?
                        "toggle_on" :
                        "toggle_off"}}</button>
                    <button class="button_icon button_icon_color icon_adjust"
                        style="margin-left: 10px;margin-right: 15px !important;"
                        (click)="onAction(1, item.v1)">currency_exchange</button>
                    <span class="en">{{item.v3}}</span>
                </div>
                <div class="col-3 cost en" [ngClass]="isDirectStockDisabled ? 'col-6' : 'col-3'">
                    <span>{{item.v2 | number: '1.2-2'}}</span>
                </div>
                <div class="col-3" *ngIf="!isDirectStockDisabled">
                    <input autocomplete="off" type="number" class="number cost"
                        (keypress)="localService.isNumberOnly($event,numericConfig)"
                        placeholder="{{localService.languageContent.common.add}}"
                        title="{{localService.languageContent.common.add}}"
                        (keydown.enter)="onAddStock($event,item.v1,item.v2)"
                        (focusout)="onAddStock($event,item.v1,item.v2)" />
                </div>
            </div>
        </div>
    </div>
</div>
<div>
    <app-batch-pricing [productId]="productId" [batchId]="selectedBatchId" [businessId]="businessId"
        [(isOpen)]="isBatchPricingPopupOpen" (onClose)="isBatchPricingPopupOpen = false" />
</div>